import { useEffect } from 'react';

export function usePageTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | SportSweeps` : 'SportSweeps';
    return () => { document.title = prev; };
  }, [title]);
}
